import { render } from "./RejectsModal.vue?vue&type=template&id=0e332fd4&scoped=true"
import script from "./RejectsModal.vue?vue&type=script&lang=js"
export * from "./RejectsModal.vue?vue&type=script&lang=js"

import "./RejectsModal.vue?vue&type=style&index=0&id=0e332fd4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e332fd4"]])

export default __exports__